// apiService.js

import { toast } from "react-toastify";

const apiUrl = process.env.REACT_APP_API_URL;

export function toastError(message) {
  toast.error(`${message}`, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    style: {
      color: "#DB0021",
      fontFamily: "Jost, Sans-serif",
      fontWeight: 700,
    },
  });
}

export function toastSuccess(message) {
  toast.success(message, {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    style: {
      color: "#198754",
      fontFamily: "Jost, Sans-serif",
      fontWeight: 700,
    },
  });
}

export function toastWarning(message) {
  toast.warning(message, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    style: {
      color: "#198754",
      fontFamily: "Jost, Sans-serif",
      fontWeight: 700,
    },
  });
}

const apiService = {
  async fetchData(endpoint, options = {}) {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${apiUrl}${endpoint}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        ...options,
      });
      if (!response.ok) {
        const respJSon = await response.json();
        console.log("ERROR resp json", respJSon);
        return { data: null, error: respJSon.msg };
      }
      const data = await response.json();
      return { data, error: null };
    } catch (error) {
      return { data: null, error: error.message };
    }
  },

  async postData(endpoint, body, options = {}) {
    const token = localStorage.getItem("token");
    return this.fetchData(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        ...options.headers,
      },
      body: JSON.stringify(body),
      ...options,
    });
  },
  async authPostData(endpoint, body, options = {}) {
    const token = localStorage.getItem("token");
    return this.fetchData(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        ...options.headers,
      },
      body: JSON.stringify(body),
      ...options,
    });
  },

  async putData(endpoint, body, options = {}) {
    return this.fetchData(endpoint, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
      body: JSON.stringify(body),
      ...options,
    });
  },

  async deleteData(endpoint, options = {}) {
    return this.fetchData(endpoint, {
      method: "DELETE",
      ...options,
    });
  },
};

export default apiService;
